import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid2, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getIntervalOptions } from "../../utils/frequentListUtils";

export const NewListDialog = ({ open, onClose, newListData, setNewListData, onCreateList }) => {
  const { t } = useTranslation();
  const intervalOptions = useMemo(() => getIntervalOptions(t), [t]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("frequentItems.createNewList")}</DialogTitle>
      <DialogContent>
        <Grid2 container spacing={2} sx={{ mt: 1 }}>
          <Grid2 xs={12}>
            <TextField
              fullWidth
              label={t("frequentItems.listName")}
              value={newListData.name}
              onChange={(e) => setNewListData({ ...newListData, name: e.target.value })}
              placeholder={t("frequentItems.groceriesPlaceholder")}
            />
          </Grid2>
          <Grid2 xs={12}>
            <FormControl fullWidth>
              <InputLabel>{t("frequentItems.shoppingInterval")}</InputLabel>
              <Select value={newListData.interval} onChange={(e) => setNewListData({ ...newListData, interval: e.target.value })} label={t("frequentItems.shoppingInterval")}>
                {intervalOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label} ({option.value} {t("frequentItems.days")})
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{t("frequentItems.intervalDescription")}</FormHelperText>
            </FormControl>
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("frequentItems.cancel")}</Button>
        <Button variant="contained" onClick={onCreateList}>
          {t("frequentItems.create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
